import type { OrderKpis } from "@acto/genui-components-schema";
import { Kpi } from "@acto/taskpane/core/domain";

export const DOMAIN_KPI: Record<OrderKpis, Kpi> = {
  revenue: Kpi.REVENUE,
  profit: Kpi.PROFIT,
  margin: Kpi.MARGIN,
  orders: Kpi.ORDERS,
};
